// extracted by mini-css-extract-plugin
module.exports = {"commentsFeed":"CommentFeed_commentsFeed__C2xM6","showMore":"CommentFeed_showMore__ju_b7"};